import React, { createContext, useContext } from "react";

export type Messages = Record<string, string>;

type TranslationContextType = {
    t: (key: string) => string;
    lingua: string;
};

const TranslationContext = createContext<TranslationContextType>({
    t: (key) => key,
    lingua: 'pt-br',
});

export function TranslationProvider({
    messages,
    lingua = 'pt-br',
    children,
}: {
    messages: Messages;
    lingua?: string;
    children: React.ReactNode;
}) {
    const t = (key: string) => messages[key] || key;
    return (
        <TranslationContext.Provider value={{ t, lingua }}>
            {children}
        </TranslationContext.Provider>
    );
}

export function useTranslation() {
    return useContext(TranslationContext);
}
